import React, { useState } from 'react';
import { Box, TextField, Button, Container, Grid, Paper, MenuItem } from '@mui/material';
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";

function ContractForm() {
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    street: '',
    siret: '',
    description: '',
    datePrestation: '',
    lieux: '',
    horaireDebout: '',
    horaireFin: '',
    nombreHeuresConvenu: '',
    tarifHeure: ''
  });
  
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Function to submit contract data to backend
  const submitContractData = async () => {
    try {
    // Retrieve the access token from local storage or state
    const user = JSON.parse(localStorage.getItem('user'));
    const accessToken = user?.accessToken;
    const requestBody = {
      ...formData,
      accessToken,
      };
      console.log("Submitting contract data:", requestBody);

      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${baseUrl}/management/generateContract`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    console.log("Response received, status:", response.status);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();
    downloadPdf(blob);
  } catch (error) {
    console.error('Error during contract generation:', error);

  }
};

  // Function to download the generated PDF
  const downloadPdf = (blob) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'contract.pdf';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="HUMAN RESOURCES" subtitle="Create New Contract" />
      </FlexBetween>
    <Container component="main" maxWidth="sm">
      <Paper style={{ padding: '20px', marginTop: '20px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Name" 
              name="name" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.name} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Surname" 
              name="surname" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.surname} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Street" 
              name="street" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.street} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="SIRET" 
              name="siret" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.siret} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              select
              fullWidth 
              label="Description" 
              name="description" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.description} 
            >
              <MenuItem value="Prestation Barman">Prestation Barman</MenuItem>
              <MenuItem value="Flair/Show">Flair/Show</MenuItem>
              <MenuItem value="Atelier Cocktail">Atelier Cocktail</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Date of Service" 
              name="datePrestation" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.datePrestation} 
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Location" 
              name="lieux" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.lieux} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Start Time" 
              name="horaireDebout" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.horaireDebout} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="End Time" 
              name="horaireFin" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.horaireFin} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Agreed Hours" 
              name="nombreHeuresConvenu" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.nombreHeuresConvenu} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Hourly Rate" 
              name="tarifHeure" 
              variant="outlined" 
              onChange={handleInputChange} 
              value={formData.tarifHeure} 
            />
          </Grid>
          <Grid item xs={12}>
            <Button 
              fullWidth 
              variant="contained" 
              color="secondary" 
              onClick={submitContractData}
            >
              Generate PDF
            </Button>
          </Grid>
        </Grid>
      </Paper>
      </Container>
      </Box>
  );
};

export default ContractForm;
